import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=f67d7d8e&scoped=true&lang=pug&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=f67d7d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67d7d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f67d7d8e')) {
      api.createRecord('f67d7d8e', component.options)
    } else {
      api.reload('f67d7d8e', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=f67d7d8e&scoped=true&lang=pug&", function () {
      api.rerender('f67d7d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrowFSFB/Messages.vue"
export default component.exports